// ============================================================================
// use-delete-account — hook mutation pour appeler l'edge fn delete-account.
// ============================================================================
// La mutation appelle `supabase.functions.invoke('delete-account', ...)` avec
// le mot de confirmation `SUPPRIMER`. En cas de succès, l'appelant est chargé
// de :
//   1. clear le cache React Query,
//   2. supabase.auth.signOut() (le user n'existe plus, la session est morte
//      mais ça retire proprement les tokens locaux),
//   3. redirect vers /login.

import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { DELETE_ACCOUNT_CONFIRM_WORD } from './delete-account-confirm';

interface DeleteAccountResult {
  ok: true;
  stripe_cancelled: number;
  stripe_failed: number;
}

async function callDeleteAccount(): Promise<DeleteAccountResult> {
  const { data, error } = await supabase.functions.invoke<DeleteAccountResult>('delete-account', {
    body: { confirm: DELETE_ACCOUNT_CONFIRM_WORD },
  });
  if (error) {
    throw new Error(error.message || 'deletion_failed');
  }
  if (!data?.ok) {
    throw new Error('deletion_failed');
  }
  return data;
}

export function useDeleteAccount() {
  return useMutation<DeleteAccountResult, Error, void>({
    mutationFn: callDeleteAccount,
  });
}
